import React, {useMemo, useEffect, useState} from 'react';

import {MESSENGER_COLORS} from 'ultra/const/messenger';

import {isEmptyObj} from 'ultra/helpers/utils';
import {ignoreTextFieldKeys, getRegexpDescription} from "ultra/helpers/utils";

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';

import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

import InputAdornment from '@mui/material/InputAdornment';

import FormControl from '@mui/material/FormControl';

import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import {useFormStore} from '../../../Stores/form';

import Phone from './Phone';

import './index.scss';

const MESSENGERS = {
    'telegram': TelegramIcon,
    'whatsapp': WhatsAppIcon,
    // 'email': AlternateEmailIcon,
    // 'other': ContactSupportOutlinedIcon,
}

const MESSENGER_NAMES = {
    whatsapp: 'WhatsApp',
    telegram: 'Telegram'
}

// ADD:
// 'Viber'
// 'Signal'

export default function Messenger(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur} = props; // content

    const {form} = useFormStore();

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const [fieldWasChanged, setFieldWasChanged] = useState(false)

    const [showSign, setShowSign] = useState(false)

    const getMessenger = () => {
        return (form[field.id] && Object.keys(form[field.id])[0]) || "";
    }

    const getTelegramType = () => {
        // const type = getMessenger();
        if (form[field.id] && form[field.id]?.[messengerTypeValue]?.phone) return 'phone';
        if (form[field.id] && form[field.id]?.[messengerTypeValue]?.username) return 'username';
        return ''
    }

    const [messengerTypeValue, setMessengerTypeValue] = useState(getMessenger())
    const [telegramTypeValue, setTelegramTypeValue] = useState(getTelegramType())
    const [phoneValue, setPhoneValue] = useState({})
    const [usernameValue, setUsernameValue] = useState('')
    const [labelValue, setLabelValue] = useState('')

    function setShowSignBlock(value) {
        if (!value) setLabelValue('');
        setShowSign(value)
    }

    const className = useMemo(() => {
        return 'MessengerField pseudoInput'
        + (isDisabled ? ' disabled' : '')
        + (showErrorText ? ' error' : '')
        + (messengerTypeValue ? '' : ' notype')
    }, [isDisabled, showErrorText, field]);

    const [regexpHighlight, setRegexpHighlight] = useState(null)

    useEffect(() => {
        const messenger = getMessenger();
        const telegramType = getTelegramType();

        // // if (!isEqual(messengerTypeValue, messenger)) 
        setMessengerTypeValue(messenger);
        if (telegramType && telegramTypeValue != telegramType) setTelegramTypeValue(telegramType);

        if (content[field.id]?.[messenger]?.phone?.number !== phoneValue.number
            ||
            content[field.id]?.[messenger]?.phone?.code !== phoneValue.code
        ) {
            setPhoneValue({...content[field.id]?.[messenger]?.phone} || {});
        }

        // if (!isEqual(usernameValue, content[field.id]?.[messengerTypeValue]?.username))
        setUsernameValue(content[field.id]?.[messenger]?.username || '');
        // if (!isEqual(labelValue, content[field.id]?.[messengerTypeValue]?.label))
        setLabelValue(content[field.id]?.[messenger]?.label || '');
    }, [form[field.id]])

    const getMessengerObject = (e) => {
        const messenger = e.target.value.toLowerCase();

        const value = {[messenger]: {phone: {}}};
        if (showSign) { value[messenger].label = '' };

        // const prevMessenger = getMessenger();
        if (form[field.id]?.[messengerTypeValue] && !isEmptyObj(form[field.id][messengerTypeValue])) {
            value[messenger] = {...form[field.id]?.[messengerTypeValue]};
        }

        return {target: {value}};
    }

    const onMessengerChange = (e) => {
        setMessengerTypeValue(e.target.value);
        setTelegramTypeValue("phone")
    }

    const onMessengerBlur = (e) => {
        if (!messengerTypeValue || (messengerTypeValue && fieldWasChanged)) {
            onBlur(getMessengerObject(e));
        }
    }

    const onTelegramTypeChange = (e) => {
        setTelegramTypeValue(e.target.value || "");

        setPhoneValue({})
        setUsernameValue("")

        // const messenger = getMessenger();
        const value = {[messengerTypeValue]: {}}
        onChange({target: {value}})
    }

    const phoneObject = (newValue) => {
        setPhoneValue(newValue)

        // const messenger = getMessenger();
        const value = {[messengerTypeValue]: {phone: newValue}}
        return {target: {value}};
    }

    const onPhoneChange = (newValue) => {
        setFieldWasChanged(true);
        onChange(phoneObject(newValue));
    }

    const onPhoneBlur = (newValue) => {
        setFieldWasChanged(true);
        onBlur(phoneObject(newValue));
    }

    const usernameObject = (e) => {
        setUsernameValue(e.target.value || "")

        // TODO:
        // add minimal 5 symbols

        // const messenger = getMessenger();
        const value = {[messengerTypeValue]: {username: e.target.value || ""}}
        return {target: {value}}
    }

    const onUsernameChange = (e) => {
        setFieldWasChanged(true);
        onChange(usernameObject(e));
    }

    const onUsernameBlur = (e) => {
        setFieldWasChanged(true);
        onBlur(usernameObject(e));
    }

    const accountRegExp = '^[0-9a-zA-Z\_]*$';
    const accountRegExpObj = new RegExp(accountRegExp);

    const onAccounKeyDownHandler = (e) => {
        if (!ignoreTextFieldKeys(e) && !accountRegExpObj.test(e.key)) {
            e.preventDefault();
            setRegexpHighlight(getRegexpDescription(accountRegExp));
        }
        else {
            setRegexpHighlight(null);
        }
    }

    const onPasteHandler = (e) => {
        const pastedData = (e.clipboardData || window.clipboardData).getData('text');
        if (!accountRegExpObj.test(pastedData)) {
            setRegexpHighlight(getRegexpDescription(accountRegExp));
            e.preventDefault();
        }
        // if (fieldErrorCheck) fieldErrorCheck(e);
    }

    const onLabelChange = (e) => {
        setLabelValue(e.target.value || "")

        // const messenger = getMessenger();
        const value = {[messengerTypeValue]: {label: e.target.value || ""}}
        onChange({target: {value}})
    }

    return (<>
        <div className={className}>
            <Grid container spacing={1}>
                <Grid item xs={12} className='ContactLabel'>
                    {field.placeholder} {field.required ? '*' : ''}
                </Grid>
                <Grid item xs={12}>
                    <div className={`ContactControlWrap ${!messengerTypeValue ? 'ContactControlWrapEmpty' : ''} ${(messengerTypeValue === 'telegram' && !telegramTypeValue) ? 'ContactControlTelegramEmpty' : ''}`}>
                        <div className='ContactControlType'>
                            <FormControl disabled={isDisabled} fullWidth className='ContactMessenger'>
                                <InputLabel>Оберіть месенджер</InputLabel>
                                <Select
                                    value={messengerTypeValue}
                                    onChange={onMessengerChange}
                                    onBlur={onMessengerBlur}
                                    error={Boolean(messengerTypeValue ? false : showErrorText)}
                                >
                                        <MenuItem value="">&nbsp;</MenuItem>
                                        {Object.keys(MESSENGERS).map(value => <MenuItem key={value} value={value}>
                                            <div className='messengerOption'>
                                                {React.createElement(MESSENGERS[value], {sx: {color: MESSENGER_COLORS[value]}})}
                                                <span className='MessengerTitle'>{MESSENGER_NAMES[value]}</span>
                                            </div>
                                        </MenuItem>)}
                                </Select>
                            </FormControl>
                        </div>

                        {messengerTypeValue === 'whatsapp' &&
                            <Phone
                                field={field}
                                value={phoneValue}
                                isDisabled={isDisabled}
                                onChange={onPhoneChange}
                                onBlur={onPhoneBlur}
                            />
                        }

                        {messengerTypeValue === 'telegram' && <>
                            <div className='ContactControlTelegramType'>
                                <FormControl disabled={isDisabled} fullWidth className='TelegramMessengerType'>
                                    <Select
                                        value={telegramTypeValue}
                                        onChange={onTelegramTypeChange}
                                    >
                                            <MenuItem value="">&nbsp;</MenuItem>
                                            <MenuItem value="phone">
                                                Телефон
                                            </MenuItem>
                                            <MenuItem value="username">
                                                Нікнейм
                                            </MenuItem>
                                    </Select>
                                </FormControl>
                            </div>

                            {telegramTypeValue === 'username' && <div className='ContactControlUsername'>
                                <TextField
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">@</InputAdornment>,
                                    }}
                                    className='ContactNumber'
                                    fullWidth
                                    disabled={isDisabled}
                                    value={usernameValue}
                                    label="Нікнейм"
                                    variant="outlined"
                                    required

                                    error={Boolean(regexpHighlight || showErrorText)}
                                    helperText={regexpHighlight || showErrorText}

                                    // InputProps={{minLength: 5}}
                                    onKeyDown={onAccounKeyDownHandler}                                    
                                    onChange={onUsernameChange}
                                    onBlur={onUsernameBlur}
                                    onPaste={onPasteHandler}
                                />
                            </div>}

                            {telegramTypeValue === 'phone' &&
                                <Phone
                                    field={field}
                                    value={phoneValue}
                                    isDisabled={isDisabled}
                                    onChange={onPhoneChange}
                                    onBlur={onPhoneBlur}
                                />
                            }
                        </>}
                    </div>
                </Grid>
                {/* className='noMargin' */}
                <Grid item xs={12}>
                    {/* <div className='fieldExample'>
                        {telegramTypeValue === 'phone' && 'Приклад: +380991234567'}
                        {telegramTypeValue === 'username' && 'Приклад: @svyatoslav_vokarchuk'}
                    </div> */}

                    {field?.options?.displayLabelField && !isEmptyObj(phoneValue) && <div className='addSign'>
                        {showSign ? '-' : '+'} <span className='pseudoLink' onClick={() => {setShowSignBlock(!showSign)}}>{showSign ? 'Приховати' : 'Додати'} підпис</span>
                    </div>}
                </Grid>

                {showSign && <Grid item xs={12}>
                    {field?.options?.displayLabelField && <TextField
                        className='ContactLabel'
                        fullWidth
                        disabled={isDisabled}
                        value={labelValue}
                        label="Підпис"
                        variant="outlined"
                        onChange={onLabelChange}
                    />}
                    {field?.options?.displayLabelField && <div className='fieldExample'>
                        Приклад: Менеджер
                    </div>}
                </Grid>}
            </Grid>
        </div>
        {!showErrorText && field?.notes && <div className='fieldNotes'>
            <p>{field?.notes}</p>
        </div>}
        {showErrorText && <div className='fieldError'>
            {showErrorText}
        </div>}
    </>)
}
